export const gitVersion = {
  "tag": "v5.5.12",
  "commit": "67ae9d152b8a66781ce08e2ec3afe9052e5d1b18",
  "branch": "main"
}